module.exports = { "default": require("core-js/library/fn/math/cosh"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/cosh.js
// module id = 1437
// module chunks = 0